import { Site } from '../constants';
import { Deserializable } from '../interfaces';

export class RegisterCustomer implements Deserializable {
  idSitio: number;
  idUsuario: number;
  nombre: string;
  correo: string;
  contrasena: string;
  telefono: string;
  idioma: string;

  constructor() {
    this.idSitio = Site.siteId;
    this.idUsuario = 0;
    this.nombre = '';
    this.telefono = '';
    this.correo = '';
    this.contrasena = '';
    this.idioma = 'esp';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
